import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BetaForm() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [interest, setInterest] = useState("creator");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Introduce un email válido");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/beta-signup`, { email, name, interest });
      setDone(true);
      toast.success("Estás dentro. Te avisaremos cuando se abra Ovamx.");
    } catch (err) {
      const msg = err?.response?.data?.detail || "No pudimos registrar tu email. Inténtalo de nuevo.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="beta-success"
        className="max-w-2xl border hairline bg-white/60 backdrop-blur-md p-6 md:p-8 rounded-2xl flex items-start gap-4"
      >
        <div className="w-10 h-10 shrink-0 rounded-full bg-coral text-cream flex items-center justify-center">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
            Confirmado
          </p>
          <p className="mt-2 font-serif text-2xl md:text-3xl leading-tight">
            Bienvenido, fundador temprano de Ovamx.
          </p>
          <p className="mt-2 text-sm text-ink/70">
            Recibirás tu invitación por email cuando se abra el acceso. Mientras tanto, comparte el manifiesto.
          </p>
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="beta-form"
      className="max-w-2xl border hairline bg-white/55 backdrop-blur-md rounded-2xl p-3 md:p-4"
    >
      <div className="flex flex-col md:flex-row gap-3 md:items-stretch">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Tu nombre (opcional)"
          data-testid="beta-name-input"
          className="bg-transparent flex-1 px-4 py-3 outline-none text-base placeholder:text-ink/40"
        />
        <input
          type="email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tu@correo.com"
          data-testid="beta-email-input"
          className="bg-transparent flex-1 px-4 py-3 outline-none text-base placeholder:text-ink/40 border-y md:border-y-0 md:border-x hairline"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="beta-submit-btn"
          className="bg-ink text-cream rounded-full px-6 py-3 text-sm hover:bg-coral transition-colors duration-500 disabled:opacity-50 inline-flex items-center justify-center gap-2 whitespace-nowrap"
        >
          {loading ? "Enviando..." : "Pedir acceso"}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M13 5l7 7-7 7" />
          </svg>
        </button>
      </div>
      <div className="mt-3 px-1 flex flex-wrap items-center gap-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid mr-2">
          Soy
        </span>
        {[
          { id: "creator", label: "creador" },
          { id: "user", label: "usuario" },
          { id: "business", label: "empresa" },
          { id: "investor", label: "inversor" },
        ].map((opt) => (
          <button
            type="button"
            key={opt.id}
            onClick={() => setInterest(opt.id)}
            data-testid={`beta-interest-${opt.id}`}
            className={`text-xs px-3 py-1 rounded-full border transition-colors ${
              interest === opt.id
                ? "bg-ink text-cream border-ink"
                : "bg-transparent border-ink/15 text-ink/70 hover:border-ink/40"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </form>
  );
}
